import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HttpclientService } from "./httpclient.service";

@Injectable()
export class FacilityService {
	constructor(private httpclientService: HttpclientService) {}
	loadFacilityList(applicationItemID) {
		var postResult$ = new Subject();
		var url = "Security/FacilityGetList?ApplicationItemID=" + applicationItemID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
	loadFacilityRPTList(applicationItemID, schoolID) {
		var postResult$ = new Subject();
		var url = "Report/FacilityRPTGetList?ApplicationItemID=" + applicationItemID + "&SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	FacilitySelectListByUser() {
		var postResult$ = new Subject();
		var url = "Report/FacilitySelectListByUser?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}
}
